import styled from "@emotion/styled";
import Texture from "./static/Texture.png";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: 48px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url(${Texture});
`;
